import SwiperGalleries  from './SwiperGallery';

const ContentDinamic = function () {

    const linkDinamic = () => {

        const linkDinamic = $('.links-dinamics');

        linkDinamic.on('click', function(e) {
            e.preventDefault();

            const el = $(e.target);
            const idDinamic = el.attr('href');

            el.parent().find('.links-dinamics').removeClass('actived');
            el.addClass('actived');

            //mobile change text
            if(el.closest('.dropdown').hasClass('dropdown-mob-aptos')) {
                const textDropMob = el.text();
                el.closest('.dropdown').find('.dropdown-toggle').text('');
                el.closest('.dropdown').find('.dropdown-toggle').text(textDropMob);
            }

            el.closest('.wrap-dinamic').find('.article-dinamic').hide(0,function() {
                $("#"+idDinamic).show();   
                
                if(el.hasClass('areas-c')) {
                    let dinTitle    = el.attr('data-title-dinamic');
                    let dinText     = el.attr('data-text-dinamic');
                    $("#dinamic-title-area-comum").html(dinTitle);                   
                    $("#dinamic-text-area-comum").html(dinText);   
                }

                setTimeout(() => {
                    SwiperGalleries.galleryPadrao();
                    SwiperGalleries.galleryAptos();
                    SwiperGalleries.galleryProjetistas();
                }, 400); 

            });

        })

    }


    return {

        linkDinamic    : linkDinamic,

    }

}();

export default ContentDinamic;